var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { VOD } from "../types/player";
import { getLocalStorageOffsetFieldName } from "./local-storage";
/** Only available for VOD - take currentTime from localstorage based on episodeId */
var startVODFrom = function (episodeId) {
    var timeStored = localStorage.getItem(getLocalStorageOffsetFieldName(episodeId));
    if (timeStored) {
        try {
            var time = parseFloat(timeStored);
            return time;
        }
        catch (_a) {
            return null;
        }
    }
    else
        return null;
};
var onTimeUpdate = function (currentTime, channelStatus, episodeId) {
    if ([VOD].includes(channelStatus)) {
        var timeInt = currentTime === null || currentTime === void 0 ? void 0 : currentTime.toString();
        localStorage.setItem(getLocalStorageOffsetFieldName(episodeId), timeInt);
    }
};
var getTextTrackLanguage = function (player) {
    var _a;
    var activeTrack = player === null || player === void 0 ? void 0 : player.getTextTracks().find(function (track) { return track.mode === "showing" && track.kind === "subtitles"; });
    return (_a = activeTrack === null || activeTrack === void 0 ? void 0 : activeTrack.language) !== null && _a !== void 0 ? _a : null;
};
/** Language of the audio track the player currently has enabled (i.e. the manifest's DEFAULT rendition until the user switches). */
var getAudioTrackLanguage = function (player) {
    var _a, _b, _c;
    var audioTracks = (_a = player === null || player === void 0 ? void 0 : player.getAudioTracks()) !== null && _a !== void 0 ? _a : [];
    var activeTrack = (_b = audioTracks.find(function (track) { return track.enabled; })) !== null && _b !== void 0 ? _b : audioTracks[0];
    return (_c = activeTrack === null || activeTrack === void 0 ? void 0 : activeTrack.language) !== null && _c !== void 0 ? _c : null;
};
/**
 * True when a track's language tag refers to the same language as `wanted`, regardless of whether
 * either side is a 2- or 3-letter ISO code or carries a region suffix (e.g. "en" / "eng" / "en-US").
 */
var isSameLanguage = function (trackLanguage, wanted) {
    if (!trackLanguage || !wanted)
        return false;
    var a = trackLanguage.toLowerCase().split("-")[0];
    var b = wanted.toLowerCase().split("-")[0];
    return a === b || transformIsoLngTwoDigits(a) === transformIsoLngTwoDigits(b);
};
var getAudioTrack = function (trackEvent) {
    var _a, _b;
    var currentAudioTrack;
    if ((_a = trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent.track) === null || _a === void 0 ? void 0 : _a.enabled) {
        currentAudioTrack = (_b = trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent.track) === null || _b === void 0 ? void 0 : _b.language;
    }
    else {
        currentAudioTrack = null;
    }
    return currentAudioTrack;
};
/**
 * ISO 639-2 (three-letter) → ISO 639-1 (two-letter) language codes.
 *
 * AWS Elemental MediaLive and MediaConvert tag HLS audio/caption renditions with ISO 639-2
 * codes, while the players (video.js / THEOplayer) match tracks on ISO 639-1. Both the
 * terminological (T) and bibliographic (B) three-letter codes are mapped where they differ
 * (deu/ger → de, fra/fre → fr, zho/chi → zh, nld/dut → nl, ...). Only languages that have a
 * two-letter ISO 639-1 code are listed; anything else falls through unchanged.
 */
var ISO_639_2_TO_1 = {
    aar: "aa",
    abk: "ab",
    afr: "af",
    aka: "ak",
    alb: "sq",
    amh: "am",
    ara: "ar",
    arg: "an",
    arm: "hy",
    asm: "as",
    ava: "av",
    ave: "ae",
    aym: "ay",
    aze: "az",
    bak: "ba",
    bam: "bm",
    baq: "eu",
    bel: "be",
    ben: "bn",
    bih: "bh",
    bis: "bi",
    bod: "bo",
    bos: "bs",
    bre: "br",
    bul: "bg",
    bur: "my",
    cat: "ca",
    ces: "cs",
    cha: "ch",
    che: "ce",
    chi: "zh",
    chu: "cu",
    chv: "cv",
    cor: "kw",
    cos: "co",
    cre: "cr",
    cym: "cy",
    cze: "cs",
    dan: "da",
    deu: "de",
    div: "dv",
    dut: "nl",
    dzo: "dz",
    ell: "el",
    eng: "en",
    epo: "eo",
    est: "et",
    eus: "eu",
    ewe: "ee",
    fao: "fo",
    fas: "fa",
    fij: "fj",
    fin: "fi",
    fra: "fr",
    fre: "fr",
    fry: "fy",
    ful: "ff",
    geo: "ka",
    ger: "de",
    gla: "gd",
    gle: "ga",
    glg: "gl",
    glv: "gv",
    gre: "el",
    grn: "gn",
    guj: "gu",
    hat: "ht",
    hau: "ha",
    heb: "he",
    her: "hz",
    hin: "hi",
    hmo: "ho",
    hrv: "hr",
    hun: "hu",
    hye: "hy",
    ibo: "ig",
    ice: "is",
    ido: "io",
    iii: "ii",
    iku: "iu",
    ile: "ie",
    ina: "ia",
    ind: "id",
    ipk: "ik",
    isl: "is",
    ita: "it",
    jav: "jv",
    jpn: "ja",
    kal: "kl",
    kan: "kn",
    kas: "ks",
    kat: "ka",
    kau: "kr",
    kaz: "kk",
    khm: "km",
    kik: "ki",
    kin: "rw",
    kir: "ky",
    kom: "kv",
    kon: "kg",
    kor: "ko",
    kua: "kj",
    kur: "ku",
    lao: "lo",
    lat: "la",
    lav: "lv",
    lim: "li",
    lin: "ln",
    lit: "lt",
    ltz: "lb",
    lub: "lu",
    lug: "lg",
    mac: "mk",
    mah: "mh",
    mal: "ml",
    mao: "mi",
    mar: "mr",
    may: "ms",
    mkd: "mk",
    mlg: "mg",
    mlt: "mt",
    mon: "mn",
    mri: "mi",
    msa: "ms",
    mya: "my",
    nau: "na",
    nav: "nv",
    nbl: "nr",
    nde: "nd",
    ndo: "ng",
    nep: "ne",
    nld: "nl",
    nno: "nn",
    nob: "nb",
    nor: "no",
    nya: "ny",
    oci: "oc",
    oji: "oj",
    ori: "or",
    orm: "om",
    oss: "os",
    pan: "pa",
    per: "fa",
    pli: "pi",
    pol: "pl",
    por: "pt",
    pus: "ps",
    que: "qu",
    roh: "rm",
    ron: "ro",
    rum: "ro",
    run: "rn",
    rus: "ru",
    sag: "sg",
    san: "sa",
    sin: "si",
    slk: "sk",
    slo: "sk",
    slv: "sl",
    sme: "se",
    smo: "sm",
    sna: "sn",
    snd: "sd",
    som: "so",
    sot: "st",
    spa: "es",
    sqi: "sq",
    srd: "sc",
    srp: "sr",
    ssw: "ss",
    sun: "su",
    swa: "sw",
    swe: "sv",
    tah: "ty",
    tam: "ta",
    tat: "tt",
    tel: "te",
    tgk: "tg",
    tgl: "tl",
    tha: "th",
    tib: "bo",
    tir: "ti",
    ton: "to",
    tsn: "tn",
    tso: "ts",
    tuk: "tk",
    tur: "tr",
    twi: "tw",
    uig: "ug",
    ukr: "uk",
    urd: "ur",
    uzb: "uz",
    ven: "ve",
    vie: "vi",
    vol: "vo",
    wel: "cy",
    wln: "wa",
    wol: "wo",
    xho: "xh",
    yid: "yi",
    yor: "yo",
    zha: "za",
    zho: "zh",
    zul: "zu"
};
/** Tags MediaLive / MediaConvert use for "not a real language" — treated as "no language". */
var NON_LANGUAGE_TAGS = new Set(["und", "mul", "mis", "zxx"]);
var transformIsoLngTwoDigits = function (langId) {
    var _a;
    if (!langId)
        return null;
    var key = langId.trim().toLowerCase();
    if (NON_LANGUAGE_TAGS.has(key))
        return null;
    // Already a 2-letter code, a region-tagged code (en-US) or an unknown value: leave untouched.
    return (_a = ISO_639_2_TO_1[key]) !== null && _a !== void 0 ? _a : langId;
};
var transformIsoLngThreeDigits = function (langId) {
    var lng = null;
    if (!langId || typeof langId === null)
        lng = null;
    switch (langId) {
        case "en":
            lng = "eng";
            break;
        case "de":
            lng = "ger";
            break;
        case "es":
            lng = "spa";
            break;
        case "fr":
            lng = "fra";
            break;
        case "it":
            lng = "ita";
            break;
        case "pt":
            lng = "por";
            break;
        case "zh":
            lng = "zho";
            break;
        case "ja":
            lng = "jpn";
            break;
        default:
            lng = langId;
            break;
    }
    return lng;
};
/**
 * Programmatically exit full screen of video
 */
var exitFullScreenMode = function () {
    var isInFullScreen = (document.fullscreenElement && document.fullscreenElement !== null) ||
        (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
        (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
        (document.msFullscreenElement && document.msFullscreenElement !== null);
    if (isInFullScreen) {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        }
        else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
        else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        }
        else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    }
};
var changeCCLanguageOfPlayer = function (player, langId) {
    try {
        var subtitleTracks = player.getTextTracks().filter(function (track) { return track.kind === "subtitles"; });
        subtitleTracks.filter(function (track) { return track.mode !== "disabled"; }).forEach(function (track) { return player.setTextTrack(track.id, "disabled"); });
        // Enable the text track for a specific language. Note: Here we are searching the label. You can also do x.language for the ISO 3 letter language code.
        var trackToActivate = subtitleTracks.find(function (track) { return track.language === transformIsoLngTwoDigits(langId) || track.language === langId; });
        if (trackToActivate)
            player.setTextTrack(trackToActivate.id, "showing");
    }
    catch (e) { }
};
var changeAudioLanguageOfPlayer = function (player, langId) { return __awaiter(void 0, void 0, void 0, function () {
    var audioTracks, trackToActivate;
    var _a;
    return __generator(this, function (_b) {
        audioTracks = (_a = player === null || player === void 0 ? void 0 : player.getAudioTracks()) !== null && _a !== void 0 ? _a : [];
        if (audioTracks.length < 2)
            return [2 /*return*/];
        trackToActivate = audioTracks.find(function (track) { return isSameLanguage(track.language, langId); });
        if (trackToActivate)
            player.setAudioTrack(trackToActivate.id);
        return [2 /*return*/];
    });
}); };
export { startVODFrom, onTimeUpdate, exitFullScreenMode, getTextTrackLanguage, getAudioTrackLanguage, isSameLanguage, transformIsoLngThreeDigits, getAudioTrack, transformIsoLngTwoDigits, changeCCLanguageOfPlayer, changeAudioLanguageOfPlayer };
